<template>
  <div id="app" :class="{ios10bug:iosBug}">

    <keep-alive :max="20">
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    <!-- data loading -->
    <DataLoading v-show="showLoading"></DataLoading>
    <!-- 城市房产 loading -->
    <CSFCLoading v-show="CsfcLoading"></CSFCLoading>
    <div id="showBack" v-if="this.$store.getters.getSourceSwitch('showBack')" class="prevback">
      <div onclick="history.go(-1)"></div>
    </div>
    <div id="footerword" class="footerword"  v-if="!$store.getters.getSourceSwitch('homePage')">
      <a href="http://www.cityhouse.cn/butlerSDK.html">本服务由禧泰数据提供</a>
      <a @click="_tel('053258552999')">客服电话：0532-58552999</a>
    </div>
    <ul class="homebar" v-if="$store.getters.getSourceSwitch('homePage')">
      <li class="icon2 activeBclick" id="living" @click="$router.push({name:'livingIndex',query:{city:selectCity}})"  v-if="$store.getters.getSourceSwitch('use_in_fcgj_app')">住在青岛</li>
      <li class="icon2 activeBclick" id="myhouse" @click="$router.push({name:'MyHouse'})">房产管家</li>
      <li class="icon1 hover activeBclick" id="selecthouse" @click="toselectHouse">智能选房</li>
      <li class="icon3 activeBclick" id="manage" @click="$router.push({name:'manage'})">我的</li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import channelInit  from '@/components/channelInit.js';

  export default {
    name: 'App',
    data(){
      return{
        footerwordfixedshow: false,
        selectCityName    :this.$store.getters.getSelectCity('name'),
        selectCity    :this.$store.getters.getSelectCity('code'),
      }
    },
    computed:mapGetters([
      'showLoading',
      'CsfcLoading'
      ]),
    mounted: function(){
      var that = this
      //用户活动状态循环函数，用户无动作15秒后循环停止
      $('body').on('touchend','div',function(){resetsystemClock()})
      window.addEventListener("popstate", function(e) {resetsystemClock()});
      function resetsystemClock(){
        if(!window.systemClock){window.systemClock_num = 0;window.systemClock = setInterval(systemClockFuntion, 500);
        }else {window.systemClock_num = 0;}
      }
      function systemClockFuntion() {
        window.systemClock_num++;
        if(window.systemClock_num>30){clearInterval(window.systemClock);window.systemClock = 0;console.log('15秒无动作')}
        //业务逻辑
        that.setJszcText()
        //固定页头
//        that.fixedHeader()
      }resetsystemClock()
      //设置渠道全局设置
      channelInit.init(this);
      //添加渠道样式和统计代码
      if(window.location.href.indexOf('orderPaySuccess')<0){
        this.addStyle();
      }

      this.addStatistics();

    },
    methods:{
      telnu:function(num){
        this._tel(num);
      },
      addStyle() {
        let body  = document.getElementsByTagName('body')[0];
        let link  = document.createElement('link');
        let cName = this.$store.getters.getChannel;//.replace(/\./g,'_')
        link.type = 'text/css';
        link.rel  = 'stylesheet';
        link.href = '/static/css/'+ cName +'.css?c='+Math.random();
        body.appendChild(link);
      },
      addStatistics() {
        if (process.env.NODE_ENV != 'production') return;
        window._hmt = null;
        let _src = this.$store.getters.getSourceSwitch('statistics');
        if (!_src) return;
        let hm = document.createElement('script');
        let _webProtocol = "https:" == document.location.protocol ? "https://" : "http://";
        hm.src = `${_webProtocol}${_src}`;
        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
        // 统计首次进入页面的链接地址
        hm.onload = () => {
          let href = location.href.replace(`${_webProtocol}${location.host}`, '');
          this.$store.getters.statistics(href);
        };
      },
      //技术支持文字位置调整（改成循环监测dom高度）
      setJszcText () {
        if(!window.fcgjdocheight)window.fcgjdocheight=1;
        let documentHeight;
        // 文档正文高度
        if(this.iosBug){
          documentHeight = document.getElementById('app').scrollHeight;
        }else{
          documentHeight = $(document).height();
        }
        if(documentHeight!=window.fcgjdocheight) {
          if("msb.mobile|customer.gjh.63045c5dbe91227a|creprice.mobile.ios|creprice.mobile.android|cityhouse.mobile.ios|cityhouse.mobile.android".indexOf(this.$store.getters.getChannel)>=0){
            $('.house-bottom').css('marginBottom','.3rem');
            $('.house-bottom-part').css('marginBottom','.3rem');
            return;
          }else if(window.location.href.indexOf('orderPaySuccess')>=1||window.location.href.indexOf('addhainfo')>=1||window.location.href.indexOf('home')>=1){
              $('#footerword').hide();return;
          }

          var footerword = $('#footerword').hide();
          var mainheight = $('#app').children('div').height() + 40
          if (mainheight >= $(window).height()) {//文档高度界面高度或者房产列表页时浮动
            footerword.removeClass('footerwordfixed')
          } else {
            footerword.addClass('footerwordfixed')
          }
          footerword.show();
//          if ((location.href + '@').indexOf('/house@') >= 0 && $('.m-list li').length>0) footerword.addClass('footerwordfixed')
          window.fcgjdocheight = documentHeight;
        }
      },
      toselectHouse:function(){
        let city=this.$store.getters.getSelectCity('code') ;
        this.$router.push({name:'selectHouse',query:{city:city}})

      }
    }
  };
</script>

<style>
  #footerword {
    display: none;
  }
  .homebar {
    height: 2rem;
    background-color: #f7f7f7;
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;border-top: 1px solid #ddd;
    color: #8A8A8A;z-index: 10000;
  }.homebar li {
     flex-grow: 1;
     text-align: center;
     padding: .1rem;
     font-size: .39rem;line-height: 2rem;
       background-size: auto .65rem;
       background-repeat: no-repeat;
       background-position: center .2rem;
   }.homebar li img {
           height: .65rem;
    }
    .homebar .hover{
      color: #e36e6f;
    }
  .homebar li.icon1 {
    background-image: url(~@/assets/images/home/bar1h.png);
  }.homebar li.icon1.hover {
    background-image: url(~@/assets/images/home/bar1.png);
  }
  .homebar li.icon2 {
    background-image: url(~@/assets/images/home/bar2h.png);
  }.homebar li.icon2.hover {
    background-image: url(~@/assets/images/home/bar2.png);
  }
  .homebar li.icon3 {
    background-image: url(~@/assets/images/home/bar3h.png);
  }.homebar li.icon3.hover {
    background-image: url(~@/assets/images/home/bar3.png);
  }

  .ios10bug{
    overflow: scroll;
    position: absolute;
  }
  link,iframe{
    height:0!important;
    position: absolute;
  }
  /*div.activeBclick:active,li.activeBclick:active,span.activeBclick:active,button.activeBclick:active{*/
    /*background-color:#eaeaea!important;color:#585858;border-radius: 8px!important;*/
  /*}*/
  div.activeBclick:active,li.activeBclick:active,a.activeBclick:active,span.activeBclick:active,button.activeBclick:active{
  background-color:#eaeaea!important;color:#585858;border-radius: 8px!important;
  }
.BMap_cpyCtrl {display: none;}
.anchorBL{display:none;}
  .footerword {
    display: block;
    text-align: center;
    line-height: 1rem;
    width: 100%;
    color: #999;
  }
  .footerwordfixed {
    position: fixed;
    bottom: 0;
    z-index: 200;
  }
  .prevback{
    /*width: 100%;*/
    height: 0.8rem;
    position: fixed;
    z-index: 9999;
    background-color: rgb(0, 0, 0, 0.3);
    border-radius: 50%;
    top: 50%;
    left: 0.1rem;
    margin-top: -0.4rem;
  }
  .prevback div{
      background: url(./assets/images/prevback_white.png) no-repeat center;
      width: 0.8rem;
      height: 0.8rem;
      background-size: 100%;
  }
  *{
    -webkit-tap-highlight-color: rgba(255,0,0,0);
    -webkit-margin-before:0px;
    -webkit-margin-after:0px;
    -webkit-padding-start:0px;
    margin: 0;
    padding:0;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    list-style: none;
    -webkit-font-smoothing:antialiased;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
  }
  html,body{
    margin: 0;
    height: 100%;
    width: 100%;
    position: relative;
    font-family: sans-serif;
    background: #f4f4f4;
  }
  input,textarea,select{
    font-size: inherit;
    border: none;
    -webkit-appearance:none;
    -webkit-user-select: text;
  }
  input:focus,textarea:focus,select:focus {outline:none;}
  input::-webkit-input-placeholder {
    color: #c8c8c8;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .hide {
    display: none;
  }
  #app {
    width: 100%;
    height: 100%;
  }
  .f-h {
    display: box;
    -webkit-box-orient: horizontal;
    -moz-box-orient: horizontal;
    display: -webkit-box;
  }
  .f-v {
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    display: -webkit-box;
  }
  .f-1 {
    -webkit-box-flex: 1;
  }
  .b-b,.b-t {
    position: relative;
  }
  .b-b:after{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid #e6e5e5;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    content: ' ';
  }
  .b-t:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #e6e5e5;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    content: ' ';
  }
  .scroll {
    overflow: scroll;
    height: 100%;
  }
  .g-nav {
    width: 100%;
    text-align: center;
    padding: 0 0.5333rem;
    display: box;
    display: -webkit-box;
    -webkit-box-pack:center;
    box-pack:center;
  }
  .g-nav.p-re{
    position: unset;
  }
  .g-nav1{
    padding: 0 0.3467rem 0.3467rem;
  }
  .g-nav1 .nav-item{
    display: inline-block;
    margin: 0.10888rem 0.06rem;
    padding: 0 0.26rem;
    height: 0.48rem;
    line-height: 0.48rem;
    font-size: 0.36rem;
    color: #666;
    border-radius: 0.04rem;
    background: #efefef;
  }
  .g-nav1 .nav-item-span{
    display: inline-block;
    margin: 0.10888rem 0.06rem 0.10888rem 0;
    padding: 0 0.2rem;
    height: 0.36rem;
    line-height: 0.36rem;
    font-size: 0.32rem;
    color: #7e888c;
    border-left: 1px solid #ccc;
  }
  .g-nav1 .nav-item-span:first-child {
    padding-left: 0;
    border-left: none;
  }
  .g-nav .nav-item{
    display: inline-block;
    margin: 0.0667rem;
    padding: 0 0.24rem;
    height: 0.48rem;
    line-height: 0.46rem;
    font-size: 0.32rem;
    color: rgba(255,255,255,0.9);
    border:0.0133rem solid rgba(255,255,255,0.9);
    border-radius: 0.48rem;
  }
  .g-nav .nav-item.b-re{
    border:0.0533rem solid #65e2b6;
  }
  .g-switch{
    width:90%;
    position: absolute;
    bottom:0.8rem;
    left:5%;
  }
  .g-switch .s-item{
    text-align: center;
  }
  .g-switch .s-item.active{
    position:relative;
  }
  .g-switch .s-item.active::after{
    position: absolute;
    bottom:-0.811rem;
    left:50%;
    margin-left: -0.6rem;
    width:1.1733rem;
    height:0.32rem;
    content: "";
    background: url("./assets/images/triangle.png") no-repeat;
    background-size: 100% 100%;
  }
  .g-switch .s-item.active .i-time{
    color: #fff;
  }
  .g-switch .s-item .i-time{
    font-size: 0.2933rem;
    color: rgba(255,255,255,0.6);
    position: relative;
    display: inline-block;
  }
  .g-switch .s-item.active .i-time::before,.g-switch .s-item.active .i-time::after{
    background: #fff;
  }
  .g-switch .s-item .i-time.beside::before,.g-switch .s-item .i-time.beside::after{
    width:0;
  }
  .g-switch .s-item .i-time::before{
    width:0.3733rem;
    height:1px;
    background: #b9e7d8;
    content: "";
    position: absolute;
    left:-0.5333rem;
    top:0.2rem;
  }
  .g-switch .s-item .i-time::after{
    width:0.3733rem;
    height:1px;
    background: rgba(255,255,255,0.6);;
    content: "";
    position: absolute;
    right:-0.5333rem;
    top:0.2rem;
  }
  .g-switch .s-item .i-price{
    color: rgba(255,255,255,0.6);
    font-size: 0.64rem;
    font-weight: 800;
    padding-top: 0.08rem;
    height: 1.18rem;
    line-height: 1.18rem;
  }
  .g-switch .s-item.active .i-price{
    color: #fff;
    font-size: 0.64rem;
    font-weight: 800;
    padding-top: 0.08rem;
    height: 1.18rem;
    line-height: 1.18rem;
  }
  .g-switch .s-item .i-unit{
    color:rgba(255,255,255,0.6);
    font-size: 0.32rem;
  }
  .g-switch .s-item.active .i-unit{
    color: #fff;
    font-size: 0.32rem;
  }
  .g-switch .s-item .i-btn{
    font-size: 0.48rem;
    padding-right: 0.2333rem;
    color: #fff;
    display: inline-block;
    padding-top: 0.8rem;
    position: relative;
  }
  .g-switch .s-item .i-btn::after{
    width:0.2133rem;
    height:0.3467rem;
    content: "";
    position: absolute;
    top:1rem;
    right:-0.1rem;
    background: url("./assets/images/arrow.png") no-repeat;
    background-size: 100% 100%;
  }
  .wc-popup-button{color:#607483!important;}
  .g-vue {
    /*height: 100%;*/
    position: relative;
    background-color: #fff;
  }
  .pig-footer {
      position: absolute;
      bottom: 0;
      text-align: center;
      color: #f2f2f2;
      font-size: 0.2867rem;
      width: 100%;
      padding: 0.3667rem;
  }
  .pig-footer span {
      padding-top: 0.3667rem;
    display: block;
  }
  .pig-footer .cityhouse_code img {
      width: 2.2267rem;
  }
  .pig-footer .share {
    width: 86%;
    margin: 0 auto;
    height: 1.4267rem;
    line-height: 1.4267rem;
    box-sizing: content-box;
    font-size: 0.4367rem;
    border: 2px solid #fff;
    border-radius: 1.567rem;
  }
  .pig-footer .share:active {
    background: rgba(255,255,255,0.2);
  }
  .pig-footer .share img {
    width: 0.8067rem;
    margin-left: 0.4rem;
    vertical-align: middle;
  }
  .g-vue.house-add {
    background: #f4f4f4;
    height: auto;
    padding-bottom: 0.4533rem;
  }
  .g-section {
    padding: 0.7467rem 6.666667% 0;
    background: #fff;
    margin-bottom: 0.08rem;
    /* overflow: auto; */
  }
  .g-section .txt{
    color: #999;
    font-size: 0.34rem;
    padding-bottom: 0.4rem;
  }
  .img2{
    width:100%;
    height:auto;
    margin-top: 0.4rem;
    padding-bottom:0.3rem;
    display: block;
  }
  .m-balance.m-ab{
    position: absolute;
    top:0.3333rem;
    left:0;
    padding:0;
    margin:0;
    width:100%;
  }
  .m-balance {
    padding: 0.3167rem 0.2667rem 0 0.99rem;
    margin-top: 0.2667rem;
  }
  .m-balance.w-re{
    padding: 0 0.8rem;
    margin-top: 0.56rem;
  }
  .m-balance.w-re1{
    padding: 0.48rem 0 0;
    text-align: center;
  }
  .m-balance .left.l-p {
    padding:0 0.9067rem;
  }
  .m-balance .right {
    text-align: left;
  }
  .m-balance > .f-1 {
    width: 0;
  }
  .right .m-label2 {
    display: inline-block;
  }
  .m-balance.m-single .m-place{
    text-align: center;
    margin: 0 auto;
  }
  .m-balance.m-ab.m-single .m-place .m-label2 .text.text1{
    text-align: center;
  }
  .m-balance.m-ab.m-single .m-place .m-label2 .label{
    text-align: center;
  }
  .m-balance.m-ab .m-place .right{
    padding:0 0.9067rem;
  }
  .m-place .f-1.p{
    padding:0 0.8rem;
  }
  .m-label1 .label,
  .m-label2 .label{
    font-size: 0.32rem;
    color: #2dc896;
    text-align: left;
  }
  .m-label2 .label2{
    color: #bbc2c0;
    font-size: 0.2667rem;
  }
  .m-label2 .label3{
    color: #a1e7d1;
    text-align: center;
    font-size: 0.2667rem;
    line-height: 0.4rem;
  }
  .m-label2 .label3 span{
    color: #fff;
  }
  .m-label2 .time{
    font-size: 0.24rem;
    background: #bbc2c0;
    display: inline-block;
    padding: 0 0.24rem;
    height:0.4267rem;
    line-height:0.4267rem;
    text-align: center;
    color: #fff;
    border-radius: 0.2133rem;
    margin-top: 0.2rem;
  }
    .m-label2 .time1{
    font-size: 0.24rem;
    background: linear-gradient(left, #29c691 0%,#58dad5 100%);
    background: -webkit-linear-gradient(left, #29c691 0%,#58dad5 100%);
    display: inline-block;
    padding: 0 0.24rem;
    height:0.4267rem;
    line-height:0.4267rem;
    text-align: center;
    color: #fff;
    border-radius: 0.2133rem;
    margin-top: 0.2rem;
  }
  .m-label1 .text {
    font-size: 0.32rem;
    color: #ababab;
  }
  .m-label2 .text {
    font-size: 0.5067rem;
    color: #bbc2c0;
    text-align: left;
    line-height: 0.88rem;
  }
  .m-label2 .text.text1 {
    font-weight: 400;
    font-size: 0.6133rem;
    color: #2dc896;
    line-height: 0.88rem;
  }
  .m-label2 .text.text3{
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
  .m-label2 .text.text3 span{
    color: #a1e7d1;
  }
  .m-label2 .text span {
    font-size: 0.2933rem;
    margin-left: 0.1333rem;
  }
  .g-title {
    -webkit-box-align: center;
  }
  .g-title .t-name {
    font-size: 0.4rem;
    color: #333;
    line-height: 0.4rem;
    padding-bottom: 0.8rem;
  }
  .g-title .t-name span{
    color: #63e5bc;
    font-size: 0.2933rem;
    padding-left: 0.1rem;
  }
  .g-title .t-btn {
    width: 0.2267rem;
    height:0.4rem;
  }
  .g-title .t-btn img{
    width: 100%;
    height:100%;
  }
  .g-tab {
    /*width: 7.3067rem;*/
    height: 0.9067rem;
    display: block;
    line-height: 0.9067rem;
    position: relative;
    text-align: center;
    background: #ee4848;
    color: #fff;
    font-size: 0.3867rem;
    /*margin: 0.5333rem auto 0;*/
    margin: 0.5333rem 0.3rem;;
    border-radius: 0.0667rem;
  }
  .g-tab.tab-beside .btn,.g-tab.tab-beside2 .btn{
    position: relative;
  }
  .g-tab.tab-beside .btn::after,.g-tab.tab-beside2 .btn::after{
    width:0.1867rem;
    height:0.36rem;
    content:"";
    position: absolute;
    top:0.4666rem;
    right:-0.4rem;
    background: url("./assets/images/detail_arrow1.png") no-repeat;
    background-size: 100%;
  }
  .g-tab.tab-beside .btn.h-price,.g-tab.tab-beside2 .btn.h-price{
    text-align: right;
    right:0.8rem;
  }
  .g-tab.tab-beside .btn.h-rent,.g-tab.tab-beside2 .btn.h-rent{
    text-align: left;
    left:0.6rem;
  }
  .g-tab.tab-beside .btn.h-rent::after,.g-tab.tab-beside2 .btn.h-rent::after{
    left:1.412rem;
  }
  .g-section1 {
    /* padding: 0 0.4933rem; */
    background-color: #fff;
  }
  .g-section1.far {
    margin-top: 1.68rem;
  }
  .g-blank {
    width: 100%;
    height: 0.2667rem;
    /* background-color: #f7f8f8; */
  }
  .g-input.address {
    height: auto;
  }
  .g-input.address .address-body{
    width: 100%;
    height: 1.2rem;
  }
  .address-extend {
    padding-bottom: 0.4rem;
  }
  .extend-item {
    width: 50%;
  }
  .extend-item:first-child {
    padding-right: 0.1333rem;
  }
  .extend-item:last-child {
    padding-left: 0.1333rem;
  }
  .extend-item .time {
    font-size: 0.3147rem;
    color: #999999;
    text-align: center;
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; */
  }
  .extend-item .price {
    font-size: 0.444rem;
    color: #333333;
    text-align: center;
  }
  .g-input {
    width: 100%;
    height: 1.2rem;
    font-size: 0.3733rem;
    padding: 0 0.4933rem;
  }
  .g-input.arrow .select{
    padding-right: 0.3467rem;
    background: url(./assets/images/select-arrow.png) no-repeat scroll right center;
    background-size: 0.2667rem 0.3733rem;
  }
  .g-input .label {
    font-size: 0.3733rem;
    color: #1d232c;
    line-height: 1.2rem;
    vertical-align: middle;
  }
  .g-input .label span {
    color: #c43036;
    display: inline-block;
    width: 0.2667rem;
    margin-left: 0.1333rem;
    vertical-align: middle;
    font-size: 0.3rem;
  }
  .g-input .select {
    width: 100%;
    height: 100%;
    line-height: 1.2rem;
    text-align: right;
    font-size: 0.3733rem;
    color: #999;
    display: block;
  }
  .g-input .select.selected {
    /* color: #1d232c; */
  }
  .g-input .input {
    width: 100%;
    display: inline-block;
    height: 1.2rem;
    /* line-height: 1.2rem; */
    text-align: right;
    font-size: 0.32rem;
    color: #999;
  }
  .g-input .input,
  .g-input .u-input1,
  .g-input .u-input2,
  .g-input .u-input3,
  .g-input .u-input4{
    color: #999;
  }
  .g-input .input::-webkit-input-placeholder,
  .g-input .u-input1::-webkit-input-placeholder,
  .g-input .u-input2::-webkit-input-placeholder,
  .g-input .u-input3::-webkit-input-placeholder,
  .g-input .u-input4::-webkit-input-placeholder {
    color: #cccccc;
  }
  .g-input .content {
    text-align: right;
  }
  .u-input1 {
    display: inline-block;
    width: 1.3333rem;
    height: 1.2rem;
    /* line-height: 1.2rem; */
    text-align: right;
    margin-right: 0.2667rem;
  }
  .u-input1:nth-child(3) {
    margin-left: 0.4rem;
  }
  .u-input1 + span,
  .u-input2 + span {
    padding: 0 0 0 0.1867rem;
    height: 0.4267rem;
    font-size: 0.2933rem;
    color: #333;
    line-height: 0.4rem;
  }
  .u-input2 {
    display: inline-block;
    /*margin-right: 0.1333rem;*/
    width: 2.6667rem;
    /*height: 1.2rem;*/
    /*line-height: 1.2rem;*/
    margin-top: 0.4067rem;
    text-align: right;
  }
  .u-input3 {
    display: inline-block;
    margin-right: 0.1333rem;
    width: 1.1667rem;
    /*height: 1.2rem;*/
    /*line-height: 1.2rem;*/
    margin-top: 0.4067rem;
    text-align: right;
  }
  .m-section {
    padding: 1.4667rem 0.4933rem 0.5333rem;
  }
  .m-section1 {
    padding: 1.0667rem 0.4933rem 0.5333rem;
  }
  .g-banner {
    position: relative;
    overflow: hidden;
  }
  .g-banner .blank {
    padding-bottom: 6.22rem;
  }
  .g-banner .blank2 {
    padding-bottom: 7.4rem;
  }
  .g-banner .blank2.beside {
    padding-bottom: 5.2rem;
  }
  .g-banner .default{
    position: absolute;
    top: 0.4533rem;
    left: 6.666667%;
    width: 86.666667%;
    height: 4.08rem;
    border-radius: 0.08rem;
    overflow: hidden;
  }
  .g-banner .default img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .g-banner .img {
    width: 100%;
    height: 99.7%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
  .g-banner .banner-content{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
  }
  .g-banner .banner-content .result{
    font-size:0.3733rem;
    color:#fff;
    text-align: center;
    padding-top: 0.266rem;
    position: relative;
  }
  .g-banner .banner-content .result::before{
    content: "";
    width:2.08rem;
    height:1px;
    background: #49d5a3;
    position: absolute;
    bottom: 0.18665rem;
    right: 1.76rem;
  }
  .g-banner .banner-content .result::after{
    content: "";
    width:2.08rem;
    height:1px;
    background: #49d5a3;
    position: absolute;
    bottom: 0.18665rem;
    left: 1.76rem;
  }
  .g-banner .banner-content .banner-title{
    padding: 1rem 0 0.8rem;
    text-align: center;
  }
  .g-banner .banner-content .banner-title img{
    width: 7.4933rem;
    height:auto;
  }
  .g-banner .banner-content .banner-p{
    font-size:0.4267rem;
    color:#fff;
    text-align:center;
    padding-bottom: 0.32rem;
  }
  .g-banner .banner-con{
    padding-bottom: 2.33rem;
    /*background: url("./assets/images/share_banner.jpg") no-repeat;*/
    background-size: 100% 99.9%;
  }
  .g-banner .banner-con2{
    padding-bottom: 3.5333rem;
    /*background: url("./assets/images/detail_bg1.png") no-repeat;*/
    background-size: 100% 99.7%;
  }
  .g-banner .banner-con .banner-title{
    padding: 1.04rem 0 0.68rem;
    text-align: center;
  }
  .g-banner .banner-con .banner-title img{
    width: 7.6933rem;
    height:auto;
  }
  .g-banner .banner-con .banner-p{
    font-size:0.4267rem;
    color:#fff;
    text-align:center;
    padding-bottom: 0.32rem;
  }
.g-banner .banner-con .result{
    font-size:0.3733rem;
    color:#fff;
    text-align: center;
    padding-top: 0.8rem;
    position: relative;
  }
  .g-banner .banner-con .result::before{
    content: "";
    width:1.8rem;
    height:1px;
    background: #c1f1e7;
    position: absolute;
    bottom: 0.18665rem;
    right: 2.04rem;
  }
  .g-banner .banner-con .result::after{
    content: "";
    width:1.8rem;
    height:1px;
    background: #c1f1e7;
    position: absolute;
    bottom: 0.18665rem;
    left: 2.04rem;
  }

  .corner-box{
    position: relative;
  }
  .corner{
    font-size:0.3067rem;
    font-weight:800;
  }
  .corner-l{
    position: absolute;
    left:-0.3933rem;
    top:0;
  }
  .corner-r{
    position: absolute;
    right:-0.3933rem;
    bottom:-0.02rem;
  }
  .title-content {
    padding: 0.6667rem 0 0.4rem;
    width: 100%;
    -webkit-box-align: center;
  }

  .title-content .title {
    white-space: nowrap;
    margin: 0 auto;
    font-size: 0.4267rem;
    font-weight: 800;
    height: 0.8rem;
    line-height: 0.8rem;
    color: #f3f7fd;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .title-content .edit {
    width: 0.1867rem;
    height: 0.36rem;
    position: absolute;
    right:0.64rem;
    top:0.22rem;
  }
  .title-content .edit img{
    width: 100%;
    height:100%;
  }
  .title-content .edit.edit1{
    width: 1.6rem;
  }
  .m-tab{
    text-align: center;
    font-size: 0.38rem;
    margin: 0 auto 0.48rem;
    width: 40%;
    height: 0.8rem;
    line-height: 0.74rem;
    border: 1px solid #e88787;
    border-radius: 4px;
    overflow: hidden;
  }
  .m-tab .item{
    color: #ee4848;
  }
  .m-tab .item.active{
    background: #ee4848;
    color: #fff;
  }
  .m-tab .item .i-txt{
    color: #a3aaa9;
  }
  .m-tab .item .i-txt.active{
    color: #00cb91;
    position: relative;
  }
  .m-tab .item .i-txt.active::after{
    position: absolute;
    left:2%;
    bottom:-0.1867rem;
    width:96%;
    height:0.08rem;
    border-radius: 0.04rem;
    content: "";
    background: linear-gradient(left, #29c691 0%,#58dad5 100%);
    background: -webkit-linear-gradient(left, #29c691 0%,#58dad5 100%);
  }
  .m-list .item {
    padding: 0.3rem;
    background-color: #fff;
    /*border: 1px solid #e6e6e6;*/
    border-left: 0;
    border-right: 0;
    overflow: hidden;
    margin: 0.3rem 0;
    position: relative;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }
  .m-list .item_re {
    margin: 0rem 0.3rem;
    margin: 0rem .3rem;
    background-color: #fff;
    -webkit-box-shadow: 0 6px 8px 0 #ccc;
    box-shadow: 0 6px 8px 0 #ccc;
    overflow: hidden;
    position: relative;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    background: -webkit-gradient(linear, left top, left bottom, from(#fff1eeab),color-stop(#fff), to(transparent));
    /* background: linear-gradient(180deg, #fff1eeab,#fff, transparent); */
    border-top: 1px solid #f9e4e4;
  }
  li.item_re.ha {
    height: 1.2rem;
    /* text-align: center; */
    margin-bottom: 0rem;
    padding: .3rem;
    font-size: .43rem;
    font-weight: bold;
    margin-top: .5rem;
    background: -webkit-gradient(linear, left top, left bottom, from(#fbded8ab),color-stop(#fff), to(transparent));
    background: linear-gradient(180deg, #ffebe6,#fff);
  }
  .m-list .item_re .g-nav1{
    padding-left:0;
    padding-bottom: 0.18rem;
    margin-top: 0.2rem;
  }
  .m-list .item .i-con{
    overflow:hidden;
    border-radius: .1rem;
  }
  .m-list .item .delete{
    padding: 0 0.416rem;
    height:100%;
    border-radius: 0.1333rem;
    box-shadow:
    0 -6px 20px #f7f8f8,
    0 6px 20px #f7f8f8;
    color: #f57272;
    font-size: 0.2933rem;
    text-align: center;
    display: flex;
    align-items:center;
    position: absolute;
    right:-1.58rem;
    top:0;
  }
  .m-list .item[data-type="0"]{
    transform: translate3d(0,0,0);
    overflow: hidden;
  }
  .m-list .item[data-type="1"]{
    transform: translate3d(-1.0667rem,0,0);
    overflow: visible;
  }
  .m-list .item.item-re{
    border-bottom: 0.28rem solid #33ca9f;
  }
  .m-list .item .title {
    font-size: 0.38rem;
    color: #666666;
    margin-bottom: 0.6rem;
    line-height: 0.4rem;
  }
  .m-list .item_re .title{
    color: #333;
    font-size: 0.4rem;
    font-weight: bold;
  }
  .m-list .item_re .title i{
      background-size: 80%!important;
      background-position-y: 0.1rem!important;
      width: 0.68rem;
      height: 0.51rem;
      display: block;
      float: right;
  }
  .m-list .item_re .title i.no{
    background:  url('./assets/images/warning-close.png') no-repeat center;
    background-size: 58%!important;
  }
  .m-list .item_re .title i.yes{
    background:  url('./assets/images/warning.png') no-repeat center;
  }
  .m-list .item .title .time{
    font-size: 0.32rem;
    color: #666666;
  }
  .m-list .item .title .edit{
    width:0.36rem;
    height:0.36rem;
    display: inline-block;
    background:  url('./assets/images/edit.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    left:0.24rem;
    top:0.052rem;
  }
  .m-list .item .title .record{
    font-size: 0.32rem;
    color: #2dc896;
    position: absolute;
    right:0.2667rem;
    top:0.02665rem;
  }
  .no-house{
    padding-top:3.44rem;
    text-align: center;
  }
  .no-house dt{
      width:1.48rem;
      display: inline-block;
  }
  .no-house dt img{
      width:100%;
      height:auto;
  }
  .no-house dd{
      padding-top: 0.4rem;
      font-size:0.3733rem;
      color: #808080;
  }
  .m-label{
    position: relative;
  }
  .m-label_re .label{
    font-size: 0.36rem;
  }
  .m-label_re .label .context{
    color: #333;
  }
  .m-label .label {
    font-size: 0.36rem;
    color: #999999 ;
  }
  .m-label .context {
    color: #b50000;
    font-weight: 600;
  }
  .m-label .unit{
    color: #b50000;
  }
  .m-label .context2 {
    color: #2dc896;
    font-size: 0.2933rem;
    position: absolute;
    right:0.2667rem;
    top:0.2161rem;
  }
  .m-btn{
    background: linear-gradient(left, #29c691 0%,#58dad5 100%);
    background: -webkit-linear-gradient(left, #29c691 0%,#58dad5 100%);
    padding: 0.2133rem 0;
    border-bottom-left-radius:0.2667rem;
    border-bottom-right-radius:0.2667rem;
  }
  .m-label .loan {
    font-size: 0.3467rem;
    color: #fff;
    text-align: center;
    height: 0.6667rem;
    line-height: 0.6667rem;
    width: 50%;
    position: relative;
  }
  .m-label .loan::after{
    width:0.2667rem;
    height:0.4rem;
    content: "";
    position: absolute;
    right:1.1rem;
    top:0.136rem;
    background:  url('./assets/images/house_arrow.png') no-repeat;
    background-size: 100%;
  }
  .m-label .loan-l{
    border-right:1px solid #3ec2a7;
  }
  .m-label .odd{
    font-size: 0.3467rem;
    color: #fff;
    text-align: center;
    height: 0.6667rem;
    line-height: 0.6667rem;
    width:100%;
    position: relative;
  }
  .m-label .odd::after{
    content: "";
    width: 0.1867rem;
    height: 0.36rem;
    position: absolute;
    right:36%;
    top:0.15335rem;
    background: url('./assets/images/detail_arrow1.png') no-repeat;
    background-size: 100%;
  }
  .g-footer{
    padding: 1.1733rem 11.74% 1.0667rem;
  }
  .g-footer h4{
    text-align: center;
    color: #323536;
    font-size: 0.4267rem;
    font-weight: 400;
  }
  .g-footer h4 span{
    color: #2dc896;
  }
  .g-footer p{
    color: #bbc2c0;
    font-size: 0.3467rem;
    padding-top: 0.6933rem;
  }
  .g-footer h5{
    color: #898989;
    font-size: 0.32rem;
    text-align: center;
    font-weight: 400;
  }
  .g-footer h5:nth-of-type(1){
    padding-top: 1.1733rem;
  }
  .g-footer .code{
    width:2.7067rem;
    display: inline-block;
  }
  .g-footer .code img{
    width:100%;
    height:auto;
  }
  .g-footer .code-text{
    text-align: left;
    color: #323536;
    font-size: 0.2667rem;
    line-height: 0.5333rem;
    text-align: center;
  }
  .g-arrow{
    font-size:0.3333rem;
    padding: 0 0.06rem;
  }

  .m-bottom {
    margin-bottom: 0.5333rem;
  }
  .g-hidden {
    /* height: 1.2rem; */
    padding: 0.4533rem 0.4933rem;
    background: #fff;
  }
  .g-hidden .arrow {
    background: url(./assets/images/arrow-down.jpg) no-repeat scroll center center;
    background-size: 0.6933rem 0.4267rem;
    width: 0.6933rem;
    height: 0.4267rem;
    margin: 0 auto 0.3333rem;
  }
  .g-hidden p {
    font-size: 0.36rem;
    color: #c1c1c1;
    text-align: center;
  }
  /* .g-hidden span {
    display: inline-block;
    width: 0.2667rem;
    height: 0.2667rem;
    background: url(./assets/images/edit_arrow.png) no-repeat scroll center center #fff;
    background-size: 100%;
    vertical-align: middle;
    margin-left: 0.1333rem;
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    -webkit-transition: all 0.3s linear;
    transition: all 0.3s linear;
  }
  .g-hidden.show span {
    -webkit-transform: rotate(0);
    transform: rotate(0deg);
  } */
  .g-checkbox {
    font-size: 0.4rem;
    line-height: 1.2rem;
    height: 100%;
    vertical-align: middle;
  }
  .g-checkbox .myCheck {
    -webkit-appearance: checkbox;
    display: none;
  }
  .g-checkbox .myCheck + .c-label{
    width:0.5333rem;
    height:0.5333rem;
    display: inline-block;
    background: url("./assets/images/unselect.png") no-repeat;
    background-size: 100%;
    position: relative;
    top: 0.1rem;
    margin-right: 0.21rem;
  }
  .g-checkbox .myCheck:checked + .c-label{
    width:0.5333rem;
    height:0.5333rem;
    display: inline-block;
    /*background: url("./assets/images/select.png") no-repeat;*/
    background-size: 100%;
  }
  /* 选择地址样式 */
  .ha-layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f7f8f8;
    z-index: 333;
  }
  .h-content {
    height: 100%;
  }
  .h-section {
    overflow-y: scroll;
  }
  .h-content .h-search{
    /* width: 90%;
    border: 1px solid #e6e5e5;
    height: 0.9867rem;
    color: #c7c8c9; */

    /* font-size: 0.3733rem;
    margin-left: 5%;
    margin-top: 0.8rem;
    color: #ababab; */
  }
  .h-section p{
    color: #c7c8c9;
    height: 1.0133rem;
    line-height: 1.0133rem;
    font-size: 0.32rem;
    padding-left: 5%;
  }
  .h-section .h-select{
    background: #fff;
  }
  .h-section .h-select .s-item{
    width: 100%;
    padding: 0.2667rem 0.4667rem;
    font-size: 0.4667rem;
    color: #000;
    /* color: #1e2427; */
    /* height: 1.1467rem; */
    /* line-height: 1.1467rem; */
    border-bottom: 1px solid #e6e5e5;
    list-style: none;
  }
  .h-section .h-select .s-item .street {
    font-size: 0.32rem;
    color: #999999;
  }

  .mobileSelect .content .btnBar .ensure{
    color: #ee4848 !important;
  }
  .noResult{
    color: #666666;
    font-size: 0.32rem;
    width: 100%;
    text-align: center;
    padding-top: 4rem;
    padding-bottom: 1rem;
    position: relative;
  }
  .noResult::before{
    position: absolute;
    top:3rem;
    left:50%;
    margin-left: -0.3333rem;
    width:0.6667rem;
    height:0.6667rem;
    content: "";
    /*background: url("./assets/images/noResult.png") no-repeat;*/
    background-size: 100% 100%;
  }
  .g-main{
  background: #fff;
  padding: 0.34rem 0.5333rem;
  margin-bottom: 0.3rem;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
}
.g-main .m-title{
  color: #333333;
  font-size: 0.38rem;
  padding-bottom: 0.18rem;
  padding-left: 1px;
}
.g-main .m-item{
  color: #808080;
  font-size: 0.36rem;
  padding-bottom: 0.18rem;
  padding-left: 1px;
}
.g-main .m-cate:nth-of-type(1){
  border-right: 1px solid #efefef;
}
.g-main .m-cate{
  text-align: center;
  width: 50%;
}
.g-main .m-cate .c-tit{
  color: #808080;
  font-size: 0.36rem;
  padding-bottom: 0.2rem;
}
.g-main .m-cate .c-info{
  color: #c1272d;
  font-size: 0.7rem;
  position: relative;
}
  .nopicture {
    background-color: #f5f5f5;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;
    text-align: center;
    background-image:url(./assets/images/default.png);
  }
/*.g-main .m-cate .c-info::after{*/
  /*position: absolute;*/
  /*top:0.36rem;*/
  /*right:0.36rem;*/
  /*width:0.2267rem;*/
  /*height:0.3333rem;*/
  /*content: "";*/
  /*background: url("./assets/images/arrow.jpg") no-repeat;*/
  /*background-size: 86% 86%;*/
/*}*/
.g-main .m-cate .c-info .unit{
  font-size: 0.36rem;
  padding-left: 0.2rem;
}
.g-main .m-cate .c-btn{
    background: #e57373;
    padding: 0 0.64rem 0 0.46rem;
    border-radius: 0.32rem;
    line-height: 0.64rem;
    color: white;
    display: inline-block;
    margin-top: 0.2rem;
    position: relative;
}
.g-main .m-cate .c-btn::after{
    position: absolute;
    top: 0;
    right: 0.14rem;
    width: 0.42rem;
    height: 0.64rem;
    content: "";
    background: url(./assets/images/house_arrow_white.png) no-repeat center;
    background-size: 64%;
}
.g-btn2{
  background: #fff;
  border-top: 1px solid #d5d3dd;
  line-height: 1.2rem;
  color: #333333;
  font-size: 0.4rem;
  position: relative;
  padding-left: 1.5rem;
}
.g-btn2:nth-last-of-type(1){
  border-bottom: 1px solid #d5d3dd;
}
.g-btn2::after{
  position: absolute;
  width:0.3333rem;
  height:0.5067rem;
  content:"";
  background: url("./assets/images/arrow2.png") no-repeat;
  background-size: 80% 80%;
  right:0.64rem;
  top:0.4rem;
}
.g-btn2.b-delete::before{
  position: absolute;
  width:0.8533rem;
  height: 0.8467rem;
  content:"";
  background: url("./assets/images/del.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top: 0.3rem;
}
.g-btn2.b-history::before{
  position: absolute;
  width:0.8533rem;
  height: 0.8467rem;
  content:"";
  background: url("./assets/images/clock.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top: 0.3rem;
}
.g-btn2.b-add::before{
  position: absolute;
  width:0.8533rem;
  height: 0.8467rem;
  content:"";
  background: url("./assets/images/star.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top:0.3rem;
}
.g-btn2.b-lease::before{
  position: absolute;
  width:0.8533rem;
  height:0.8667rem;
  content:"";
  background: url("./assets/images/lease.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top:0.3rem;
}
.g-btn2.b-forsale::before{
  position: absolute;
  width:0.8533rem;
  height:0.8667rem;
  content:"";
  background: url("./assets/images/forsale.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top:0.3rem;
}
.g-btn2.b-warn::before{
  position: absolute;
  width:0.8533rem;
  height:0.8667rem;
  content:"";
  background: url("./assets/images/warn.png") no-repeat;
  background-size: 70% 70%;
  left:0.5333rem;
  top:0.3rem;
}
  .g-agree {
    color: #999;
    font-size: 0.36rem;
    text-align: center;
    line-height: 0.64rem;
    margin-top: 0.3rem;
  }
  .g-agree i {
    background: url("./assets/images/agree.png") no-repeat center;
    background-size: 100%;
    width: 0.52rem;
    height: 0.52rem;
    display: inline-block;
    vertical-align: text-top;
    margin-right: 0.2rem;
  }
  .g-agree i.select {
    background: url("./assets/images/agree_select.png") no-repeat center;
    background-size: 100%;
  }
  .g-agree i.after{
    /*content:'';*/
    background: url("./assets/images/wenhao.png") no-repeat center;
    background-size: 70%;
    width: 0.48rem;
    height: 0.48rem;
    display: inline-block;
    vertical-align: text-top;
    margin-left: 0.2rem;
  }
  .run-enter,
  .run-leave-to {
    opacity: 0;
    top: 12rem;
  }
  .run-enter-to,
  .run-leave {
    opacity: 1;
    top: 0;
  }
  .run-enter-active,
  .run-leave-active {
    transition: all 0.5s;
  }

  .runxf-enter,
  .runxf-leave-to {
    opacity: 0;
  }
  .runxf-enter-to,
  .runxf-leave {
    opacity: 1;
  }
  .runxf-enter-active,
  .runxf-leave-active {
    transition: all 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue